// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__lKrqH","trigger-text":"Tooltip_trigger-text__9GesW","arrow":"Tooltip_arrow__4gpyP"};